// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as IconChevronRight$Showside from "../icons/IconChevronRight.bs.js";
function useBreadcrumbs(keepLast, keepSingle, max, categories) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  var match$1 = ViewportContext$Showside.use(undefined);
  var max$1 = Belt_Option.getWithDefault(max, match$1.isMobile ? 3 : 8);
  var listPageType;
  listPageType = typeof route === "number" || route.TAG !== /* ListPage */1 ? undefined : route._0.listPageType;
  var activeCategoryId = listPageType !== undefined && !(typeof listPageType === "number" || listPageType.TAG !== /* Category */0) ? listPageType._0 : undefined;
  var path = activeCategoryId !== undefined ? Belt_Array.keep(Category$Showside.getCategoryPathById(categories, activeCategoryId), function (category) {
    return category.title.trim() !== "";
  }) : [];
  var path$1 = Belt_Array.map(Belt_Option.mapWithDefault(Belt_Option.keep(Belt_Array.get(categories, 0), Category$Showside.isIndexNode), path, function (index) {
    return Belt_Array.concat([index], path);
  }), function (category) {
    return {
      label: category.title,
      id: category.id,
      disabled: Caml_obj.equal(category.id, activeCategoryId),
      dataTestId: Caml_obj.equal(category.id, activeCategoryId) ? "clp-sectionheader-title" : undefined
    };
  });
  var truncateStart = path$1.length > max$1 ? (path$1.length - 1 | 0) - max$1 | 0 : 0;
  var truncateEnd = path$1.length;
  var path$2 = Belt_Array.keepWithIndex(path$1, function (item, idx) {
    if (idx !== (path$1.length - 1 | 0)) {
      return true;
    } else {
      return keepLast;
    }
  });
  var truncating = path$2.length > max$1;
  var path$3 = path$2.slice(truncateStart, truncateEnd);
  var show = path$3.length > 1 || keepSingle;
  return {
    show: show,
    truncating: truncating,
    path: path$3
  };
}
function Breadcrumbs$Show(Props) {
  var classNameOpt = Props.className;
  var hook = Props.hook;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var path = hook.path;
  var match$1 = ViewportContext$Showside.use(undefined);
  var separator = React.createElement(IconChevronRight$Showside.make, {
    className: CSS$Showside.prefix("opacity-50")
  });
  var content = React.createElement(DataAttribute$Showside.make, {
    dataTestId: "breadcrumbs",
    children: React.createElement("ul", {
      className: Cn.make([className, CSS$Showside.prefix("w-full text-secondary truncate flex flex-row items-center list-none"), match$1.isMobile ? CSS$Showside.prefix("space-x-3") : CSS$Showside.prefix("space-x-4")])
    }, hook.truncating ? React.createElement(React.Fragment, undefined, React.createElement("li", {
      "aria-hidden": true,
      tabIndex: -1
    }, "..."), React.createElement("li", {
      "aria-hidden": true,
      tabIndex: -1
    }, separator)) : null, Belt_Array.mapWithIndex(path, function (idx, item) {
      var isLast = idx === (path.length - 1 | 0);
      var tmp = {
        className: CSS$Showside.prefix(Cn.make(["whitespace-nowrap", "text-lg", item.disabled ? "" : "cursor-pointer", "font-normal"])),
        onClick: function (param) {
          if (item.disabled) {
            return;
          } else {
            var match = item.id;
            var tmp = match === "index" ? {
              TAG: /* Home */0,
              _0: {
                homeType: /* Index */0,
                filters: undefined,
                sort: undefined
              }
            } : {
              TAG: /* ListPage */1,
              _0: {
                listPageType: {
                  TAG: /* Category */0,
                  _0: item.id
                },
                viewPLP: false,
                filters: undefined,
                sort: undefined
              }
            };
            return Curry._3(goTo, undefined, undefined, tmp);
          }
        }
      };
      var tmp$1 = item.disabled ? undefined : "link";
      if (tmp$1 !== undefined) {
        tmp.role = Caml_option.valFromOption(tmp$1);
      }
      var tmp$2 = item.disabled ? undefined : 0;
      if (tmp$2 !== undefined) {
        tmp.tabIndex = Caml_option.valFromOption(tmp$2);
      }
      var tmp$3 = {
        children: React.createElement("div", undefined, React.createElement("div", undefined, item.label))
      };
      if (item.dataTestId !== undefined) {
        tmp$3.dataTestId = Caml_option.valFromOption(item.dataTestId);
      }
      return React.createElement(React.Fragment, {
        children: null,
        key: item.id
      }, React.createElement(DataAttribute$Showside.make, {
        dataTestId: "breadcrumb-item",
        dataId: item.id,
        children: React.createElement("li", tmp, React.createElement(DataAttribute$Showside.make, tmp$3))
      }), isLast ? null : React.createElement("li", {
        "aria-hidden": true,
        className: CSS$Showside.prefix("text-lg"),
        tabIndex: -1
      }, separator));
    }))
  });
  return React.createElement("div", {
    "aria-label": "Breadcrumbs",
    role: "navigation"
  }, content);
}
Breadcrumbs$Show.displayName = "Breadcrumbs.Show";
var Show = {
  make: Breadcrumbs$Show
};
function Breadcrumbs(Props) {
  var categories = Props.categories;
  var classNameOpt = Props.className;
  var keepLastOpt = Props.keepLast;
  var keepSingleOpt = Props.keepSingle;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var keepLast = keepLastOpt !== undefined ? keepLastOpt : false;
  var keepSingle = keepSingleOpt !== undefined ? keepSingleOpt : false;
  var hook = useBreadcrumbs(keepLast, keepSingle, undefined, categories);
  if (hook.show) {
    return React.createElement(Breadcrumbs$Show, {
      className: className,
      hook: hook
    });
  } else {
    return null;
  }
}
Breadcrumbs.displayName = "Breadcrumbs";
var make = Breadcrumbs;
export { useBreadcrumbs, Show, make };
/* react Not a pure module */